// @cloudflare/codemode/ai has been rewritten.
// Use createCodeTool from @cloudflare/codemode/ai instead.
throw new Error(
  "This entrypoint has been removed. Use createCodeTool() from @cloudflare/codemode/ai instead."
);
